import React, { InputHTMLAttributes, useEffect, useRef, useState } from "react";
import styles from "./Input.module.scss";
import EyeIcon from "../../../assets/svgs/eye/EyeIcon.";
import EyeClosedIcon from "../../../assets/svgs/eye/EyeClosedIcon";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  placeholder?: string;
  error?: string;
  phone?: boolean;
}

const Input: React.FC<InputProps> = ({
  label,
  placeholder,
  error,
  className = "",
  phone = false,
  type = "text",
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const prefix = "+994";
  const [showPassword, setShowPassword] = useState(false);

  const isPassword = type === "password";

  useEffect(() => {
    if (phone && inputRef.current) {
      if (!inputRef.current.value.startsWith(prefix)) {
        inputRef.current.value = prefix;
      }
    }
  }, [phone]);

  const handleFocus = () => {
    if (phone && inputRef.current) {
      const len = inputRef.current.value.length;
      if (len < prefix.length) {
        inputRef.current.value = prefix;
      }
      inputRef.current.setSelectionRange(len, len);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (phone) {
      if (!e.target.value.startsWith(prefix)) {
        e.target.value = prefix;
      }
    }
    rest.onChange?.(e);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (phone && inputRef.current) {
      const pos = inputRef.current.selectionStart ?? 0;
      if (
        pos <= prefix.length &&
        (e.key === "Backspace" || e.key === "Delete")
      ) {
        e.preventDefault();
      }
    }
    rest.onKeyDown?.(e);
  };

  return (
    <div className={`${styles.inputWrapper} ${className}`}>
      {label && <label className={styles.label}>{label}</label>}

      <div className={styles.inputContainer}>
        <input
          ref={inputRef}
          style={{ paddingRight: isPassword ? "40px" : "" }}
          className={`${styles.input} ${error ? styles.inputError : ""}`}
          placeholder={phone ? "+994 XX XXX XX XX" : placeholder}
          onFocus={handleFocus}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          maxLength={phone ? 13 : undefined}
          type={isPassword ? (showPassword ? "text" : "password") : type}
          {...rest}
        />
        {isPassword && (
          <button
            type="button"
            className={styles.icon}
            onClick={() => setShowPassword((prev) => !prev)}
          >
            {showPassword ? <EyeIcon /> : <EyeClosedIcon />}
          </button>
        )}
      </div>

      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
};

export default Input;
